export function getFromLocalStorage<T>(key: string): T | undefined {
  try {
    const dataString = localStorage.getItem(key);

    if (dataString) {
      return JSON.parse(dataString);
    }
  } catch (error) {
    console.log(error);
  }
}
